export default __webpack_public_path__ + "static/media/i.4569c6e7.png";